import { inject, Injectable } from '@angular/core';
import { Polygon } from 'geojson';

import { ProjectBloc } from '@connect-services/client/blocs/project.bloc';
import { ProjectColors } from '@connect-services/client/components/color-dropdown/color-dropdown.component';
import { ProjectService } from '@connect-services/client/services/project.service';
import { ProjectCreationEditionForm } from '@connect-services/client/services/project/shaping/shaping-project.service';
import {
    ProjectDefaultData,
    ShapingProjectState,
} from '@connect-services/client/services/project/shaping/shaping-state/shaping-project-state';

@Injectable({
    providedIn: 'root',
})
export class EditProjectShapingStateService extends ShapingProjectState {
    public form!: ProjectCreationEditionForm;
    public title: string = 'editProject';

    private readonly projectBloc = inject(ProjectBloc);
    private readonly projectService = inject(ProjectService);

    public clear(): void {
        this.defaultData = undefined;
        this.form.reset();
    }

    public getDefaultData(): ProjectDefaultData | undefined {
        if (!this.defaultData) {
            this.setDefaultData();
        }

        return this.defaultData;
    }

    public async onConfirm(form: ProjectCreationEditionForm): Promise<void> {
        await this.projectService.updateProject(form);
    }

    public setDefaultData(data?: ProjectDefaultData): void {
        if (data) {
            this.defaultData = data;
            this.initForm();

            return;
        }

        const currentProject = this.projectBloc.value();
        const bbox = currentProject?.bbox ? (currentProject.bbox as unknown as Polygon) : null;
        this.defaultData = {
            bbox: bbox,
            color: currentProject?.color as ProjectColors,
            name: currentProject?.name,
            projection: currentProject?.projection,
        };
        this.initForm();
    }
}
